import React from 'react';
import { motion } from 'framer-motion';
const modules = [{
  num: '01',
  emoji: '📘',
  title: 'Planificación Inteligente',
  desc: 'Organizá todo el ciclo lectivo con planificaciones anuales, secuencias y objetivos ya preparados.'
}, {
  num: '02',
  emoji: '👶',
  title: 'Sala de 18 Meses',
  desc: 'Propuestas sensoriales, juegos y actividades listas para trabajar con bebés y deambuladores.'
}, {
  num: '03',
  emoji: '🌎',
  title: 'Sala de 2 Años',
  desc: 'Planificaciones completas, experiencias de aprendizaje y recursos para desarrollar lenguaje, juego y autonomía.'
}, {
  num: '04',
  emoji: '🚀',
  title: 'Sala de 3 Años',
  desc: 'Actividades listas para imprimir y aplicar que potencian el aprendizaje mediante el juego.'
}, {
  num: '05',
  emoji: '📅',
  title: 'Calendario Escolar',
  desc: 'Efemérides, actos, fechas especiales y organización anual completamente resuelta.'
}, {
  num: '06',
  emoji: '📝',
  title: 'Registro Docente',
  desc: 'Informes, diagnósticos, seguimientos, evaluaciones y documentación profesional lista para completar.'
}];
export function ModulesSection() {
  return <section className="py-16 md:py-24 bg-[#f8f8f8] pt-[30px] pb-[30px]" data-id="element-107">
      <div className="container mx-auto px-4 max-w-[1100px]" data-id="element-108">
        <div className="text-center mb-12" data-id="element-109">
          <h2 className="font-heading font-extrabold text-[#1a2e5a] text-4xl md:text-5xl leading-tight mb-4" data-id="element-110">
            EL NÚCLEO DEL MEGAPACK
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 font-bold" data-id="element-111">
            6 Tomos Completos Listos para Usar
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-112">
          {modules.map((m, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="flex flex-col bg-white border border-slate-200 rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-113">
              <div data-id="element-114">
                <h3 className="font-heading font-bold text-[#1a2e5a] text-xl mb-3 leading-snug flex items-center gap-3" data-id="element-115">
                  <span className="text-3xl flex-shrink-0" aria-hidden="true" data-id="element-116">
                    {m.emoji}
                  </span>
                  {m.title}
                </h3>
                <p className="text-slate-600 leading-relaxed text-[15px]" data-id="element-117">
                  {m.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}